import { isFirstOfflineDataRestoring } from '../../../../queryClient/offlineQueryClient';
import { waitOfflineEncryptionKey } from '../../../../utils/waitOfflineEncryptionKey.util';
import { QueryKeysAndFnOptions } from '../../../useOfflineDataDownloader/hooks/useQueryKeysAndFnToCache/useQueryKeysAndFnToCache.types';
import { QueryKeysAndFnToAutoUpdateGeneratorConstructorParams } from './types/queryKeysAndFnToAutoUpdateGenerator.types';

export abstract class OfflineAutoUpdateFilter {
  abstract filter(): Promise<QueryKeysAndFnOptions> | QueryKeysAndFnOptions;
}

export class QueryKeysAndFnToAutoUpdateGenerator {
  private filters: OfflineAutoUpdateFilter[] = [];

  constructor({
    queryKeysAndFnOptions: _queryKeysAndFnOptions,
    teamId: _teamId,
  }: QueryKeysAndFnToAutoUpdateGeneratorConstructorParams) {
    this.filters = [];
  }

  async generate() {
    await isFirstOfflineDataRestoring;
    await waitOfflineEncryptionKey();

    const optionsToUpdate: QueryKeysAndFnOptions = [];

    for (const filter of this.filters) {
      const filteredOptions = await filter.filter();

      if (filteredOptions.length > 0) {
        optionsToUpdate.push(...filteredOptions);
      }
    }

    return optionsToUpdate;
  }
}
